<template>
    <v-card class="round-card background-2 mt-4 pb-3" v-if="subscriptions.length > 0">
        <v-card-title class="pa-3 cursor-pointer" @click="expanded = !expanded">
            <v-icon color="purple" class="mr-2" small>mdi-autorenew</v-icon>
            <span class="subtitle-2">Abbonamenti ({{ subscriptions.length }})</span>
            <v-spacer></v-spacer>
            <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>

        <v-expand-transition>
            <div v-show="expanded">
                <v-divider></v-divider>
                <v-list dense class="pa-0 background-2">
                    <v-list-item
                        v-for="subscription in subscriptions"
                        :key="subscription.id"
                        @click="openSubscription(subscription.id)"
                        class="cursor-pointer"
                    >
                        <v-list-item-content>
                            <v-list-item-subtitle class="d-flex align-center justify-space-between">
                                <span>{{ formatDateRange(subscription.billing_start_date, subscription.billing_end_date) }}</span>
                                <v-chip v-if="subscription.subscription_type_text" x-small :color="subscription.subscription_type_color || 'grey'" dark>
                                    {{ subscription.subscription_type_text }}
                                </v-chip>
                            </v-list-item-subtitle>
                            <v-list-item-title class="d-flex align-center">
                                <span class="font-weight-bold mr-2">{{ subscription.code }}</span>
                                <span class="text-truncate">{{ subscription.name }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { format } from 'date-fns'

export default {
    name: 'CompanySubscriptions',

    props: {
        companyId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            subscriptions: [],
            loading: false,
            expanded: true
        }
    },

    watch: {
        companyId: {
            immediate: true,
            handler(val) {
                if (val) this.loadSubscriptions()
            }
        }
    },

    methods: {
        async loadSubscriptions() {
            if (!this.companyId) return

            this.loading = true
            try {
                const response = await this.axios.get(`helpdesktroubles/company/${this.companyId}/subscriptions`)
                this.subscriptions = response.data.data || []
            } catch (error) {
                console.error('Error loading company subscriptions:', error)
            } finally {
                this.loading = false
            }
        },

        openSubscription(subscriptionId) {
            const route = this.$router.resolve({
                name: 'subscriptions-show',
                params: { id: subscriptionId }
            })
            window.open(route.href, '_blank')
        },

        formatDateRange(start, end) {
            const startStr = start ? format(new Date(start), 'dd/MM/yy') : ''
            const endStr = end ? format(new Date(end), 'dd/MM/yy') : ''
            return `${startStr} - ${endStr}`
        }
    }
}
</script>
